'use client';

import { Skeleton } from '@/components/ui/skeleton';
import { TableRow, TableCell } from '@/components/ui/table';

interface SubscriptionPaymentsTableSkeletonProps {
    rows?: number;
}

export function SubscriptionPaymentsTableSkeleton({ rows = 5 }: SubscriptionPaymentsTableSkeletonProps) {
    return (
        <>
            {Array.from({ length: rows }).map((_, index) => (
                <TableRow key={index}>
                    <TableCell>
                        <Skeleton className="h-4 w-4" />
                    </TableCell>
                    <TableCell>
                        <Skeleton className="h-4 w-20" />
                    </TableCell>
                    <TableCell>
                        <Skeleton className="h-4 w-16" />
                    </TableCell>
                    <TableCell>
                        <Skeleton className="h-6 w-20" />
                    </TableCell>
                    <TableCell>
                        <Skeleton className="h-4 w-24" />
                    </TableCell>
                    <TableCell>
                        <Skeleton className="h-4 w-20" />
                    </TableCell>
                </TableRow>
            ))}
        </>
    );
}
